import { FinanceModel } from './finance.model';
import { UserModel } from './user.model';

export class FileFinanceModel {
    file_finance_id: number;

    path: string;

    type_file: string;

    name: string | null;

    finance_id: number;

    finance: FinanceModel;

    user_id: number | null;

    user: UserModel | null;

    createdAt: Date;

    constructor(data?: Partial<FileFinanceModel>) {
        this.file_finance_id = data?.file_finance_id ?? null;

        this.path = data?.path ?? null;

        this.type_file = data?.type_file ?? null;

        this.name = data?.name ?? null;

        this.finance_id = data?.finance_id ?? null;

        this.finance = data?.finance ?? null;

        this.user_id = data?.user_id ?? null;

        // Garantir que user seja mapeado como UserModel se existir
        this.user = data?.user ? new UserModel(data.user) : null;

        this.createdAt = data?.createdAt ?? null;
    }
}
